import { useState } from 'react';
import { useApp } from '../state';
import { PageHead } from '../ui';
import { TopBar } from './TopBar';
import { Hourly } from './Hourly';
import { MyShift } from './MyShift';
import { OtherTasks } from './OtherTasks';
import { ProdBoard } from './ProdBoard';

type Mode = 'shift' | 'board' | 'hourly' | 'tasks';
const LABEL: Record<Mode, string> = { shift: 'Моя смена', board: 'Доска', hourly: 'По часам', tasks: 'Проверки' };

function loadMode(def: Mode): Mode {
  try {
    const v = localStorage.getItem('tasks.mode') as Mode | null;
    return v && v in LABEL ? v : def;
  } catch {
    return def;
  }
}

/**
 * Вкладка «Задачи»: моя смена (таймер, выработка, закрытие), доска этапов производства,
 * производство по часам (онлайн) и проверки/прочие задачи.
 */
export function Tasks({ initial }: { initial?: Mode }) {
  const { me } = useApp();
  const [mode, setModeState] = useState<Mode>(() => initial ?? loadMode(me.manager ? 'board' : 'shift'));
  const setMode = (m: Mode) => {
    setModeState(m);
    try {
      localStorage.setItem('tasks.mode', m);
    } catch {
      /* нет хранилища */
    }
  };
  return (
    <div className="stack">
      <TopBar />
      <PageHead title="Задачи" />
      <div className="seg seg-fit" role="tablist" aria-label="Раздел задач">
        {(Object.keys(LABEL) as Mode[]).map((m) => (
          <button key={m} type="button" role="tab" aria-selected={mode === m} aria-pressed={mode === m} onClick={() => setMode(m)}>
            {LABEL[m]}
          </button>
        ))}
      </div>
      {mode === 'shift' && <MyShift />}
      {mode === 'board' && <ProdBoard />}
      {mode === 'hourly' && <Hourly />}
      {mode === 'tasks' && <OtherTasks />}
    </div>
  );
}
